import { CampaignDto } from '../../../models/dtos/campaign.dto';
import axios from '../../axios';

export default async function getCampaignPopRequest(): Promise<CampaignDto> {
  const response = await axios.get<CampaignDto>(
    `${process.env.REACT_APP_BASE_URL}/users/campaign/pop`
  );
  return response.data;
}
